import PropTypes from 'prop-types'
import React, { Component, useContext, useState, createRef } from 'react'
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { dbClicks } from '../firebase'
import { AppState } from '../context';
import emailPush from './EmailKeeper'
import ContactUs from './ContactUs'

import {
        Loader,
        Card,
        Ref,
        Rail,
        Sticky,
        Button,
        Container,
        Divider,
        Grid,
        Header,
        Icon,
        Image,
        List,
        Menu,
        Responsive,
        Segment,
        Sidebar,
        Visibility,
        Dimmer,
        Form
} from 'semantic-ui-react'
import EmailReader from './EmailKeeper';
import ModalBlogLogin from './ModalBlogLogin';


const getWidth = () => {
        const isSSR = typeof window === 'undefined'

        return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}

const HomepageHeading = ({ mobile }) => (
        <Container text>
                <Header
                        as='h1'
                        content='Discover our simple solution to streamline senior care.'
                        inverted
                        style={{
                                fontSize: mobile ? '2em' : '4em',
                                fontWeight: 'normal',
                                marginBottom: 0,
                                marginTop: mobile ? '1.5em' : '3em',
                        }}
                />

        </Container>
)

HomepageHeading.propTypes = {
        mobile: PropTypes.bool,
}

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
        state = {}

        hideFixedMenu = () => this.setState({ fixed: false })
        showFixedMenu = () => this.setState({ fixed: true })

        render() {
                const { children } = this.props
                const { fixed } = this.state

                return (
                        <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
                                <Visibility
                                        once={false}
                                        onBottomPassed={this.showFixedMenu}
                                        onBottomPassedReverse={this.hideFixedMenu}
                                >
                                        <Segment
                                                inverted
                                                textAlign='center'
                                                style={{ minHeight: 700, padding: '1em 0em' }}
                                                vertical
                                        >
                                                <Menu
                                                        fixed={fixed ? 'top' : null}
                                                        inverted={!fixed}
                                                        pointing={!fixed}
                                                        secondary={!fixed}
                                                        size='large'
                                                >
                                                        <Container>
                                                                <Menu.Item href='/' fluid>
                                                                        Home
                </Menu.Item>
                                                                <Menu.Item href='/blog' fluid >
                                                                        Blog
                </Menu.Item>
                                                                <Menu.Item href='/tutorial' fluid>
                                                                        How It Works
                </Menu.Item>
                                                                <Menu.Item href='/zipcoderesources' fluid>
                                                                        COVID-19 resources
                </Menu.Item>
                                                                {/* <Menu.Item href='/requestdemo' active fluid>
                                                                        Request Demo
                </Menu.Item> */}
                                                                <Menu.Item href='/contactus' active fluid>
                                                                        Contact Us
                </Menu.Item>

                                                        </Container>
                                                </Menu>
                                                <HomepageHeading />
                                        </Segment>
                                </Visibility>

                                {children}
                                <Segment style={{ padding: '4em 0em' }} vertical>
                                        <Grid container >
                                                <Grid.Row>
                                                        <Grid.Column width={14}>
                                                                <Header as='h3' style={{ fontSize: '2em' }}>
                                                                        About us
          </Header>
                                                                <p style={{ fontSize: '1.33em' }}>
                                                                        We are a Northwestern based start-up radically innovating the way we care.
          </p>
                                                                <Header as='h3' style={{ fontSize: '2em' }}>
                                                                        Contact Us:
          </Header>
                                                                <p style={{ fontSize: '1.33em' }}>
                                                                        Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                                                                        call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                                                                {/* </Grid.Column> */}
                                                        </Grid.Column>
                                                </Grid.Row>


                                                <Grid.Row>
                                                        <Grid.Column textAlign='center'>
                                                                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
                                                        </Grid.Column>
                                                </Grid.Row>

                                        </Grid>
                                </Segment>
                                <Segment inverted vertical style={{ padding: '5em 0em' }}>
                                        <Container>
                                                <Grid divided inverted stackable>
                                                        <Grid.Row>
                                                                <Grid.Column width={3}>
                                                                        <Header inverted as='h4' content='Follow us' />
                                                                        <List link inverted>
                                                                                <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                                                                                <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                                                                                <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>

                                                                        </List>
                                                                </Grid.Column>
                                                                <Grid.Column width={3}>
                                                                        <Header inverted as='h4' content='Contact us' />
                                                                        <List link inverted>
                                                                                <List.Item>homecarenuvention@gmail.com</List.Item>

                                                                        </List>
                                                                </Grid.Column>
                                                                <Grid.Column width={7}>
                                                                        <Header as='h4' inverted>
                                                                                Homecare
            </Header>
                                                                        <p>
                                                                                Help us help you care.
            </p>
                                                                </Grid.Column>
                                                        </Grid.Row>
                                                </Grid>
                                        </Container>
                                </Segment>
                        </Responsive>
                )
        }
}

DesktopContainer.propTypes = {
        children: PropTypes.node,
}

class MobileContainer extends Component {
        state = {}

        handleSidebarHide = () => this.setState({ sidebarOpened: false })

        handleToggle = () => this.setState({ sidebarOpened: true })

        render() {
                const { children } = this.props
                const { sidebarOpened } = this.state

                return (
                        <Responsive
                                as={Sidebar.Pushable}
                                getWidth={getWidth}
                                maxWidth={Responsive.onlyMobile.maxWidth}
                        >
                                <Sidebar
                                        as={Menu}
                                        animation='push'
                                        inverted
                                        onHide={this.handleSidebarHide}
                                        vertical
                                        visible={sidebarOpened}
                                >
                                        <Menu.Item href='/'>
                                                Home
          </Menu.Item>
                                        <Menu.Item href='/blog'>
                                                Blog
          </Menu.Item>
                                        <Menu.Item href='/tutorial' fluid>
                                                How It Works
          </Menu.Item>
                                        <Menu.Item href='/zipcoderesources' fluid>
                                                COVID-19 resources
          </Menu.Item>
                                        {/* <Menu.Item href='/requestdemo' active fluid>
                                                Request Demo
                </Menu.Item> */}
                                        <Menu.Item href='/contactus' fluid>
                                                Contact Us
                </Menu.Item>

                                        <Menu.Item as={Link} to={'/familymembers'}>Log in families</Menu.Item>

                                        <Menu.Item as={Link} to={'/caregivers'}>Log in caregiver</Menu.Item>
                                </Sidebar>

                                <Sidebar.Pusher dimmed={sidebarOpened}>
                                        <Segment
                                                inverted
                                                textAlign='center'
                                                style={{ minHeight: 350, padding: '1em 0em' }}
                                                vertical
                                        >
                                                <Container>
                                                        <Menu inverted pointing secondary size='large'>
                                                                <Menu.Item onClick={this.handleToggle}>
                                                                        <Icon name='sidebar' />
                                                                </Menu.Item>
                                                        </Menu>
                                                </Container>
                                                <HomepageHeading mobile />
                                        </Segment>
                                        {children}
                                </Sidebar.Pusher>
                                <Divider />
                                <Segment style={{ padding: '4em 0em', marginTop: "-20px" }} vertical>
                                        <Grid container >
                                                <Grid.Row>
                                                        <Grid.Column width={14}>
                                                                <Header as='h3' style={{ fontSize: '2em' }}>
                                                                        About us
          </Header>
                                                                <p style={{ fontSize: '1.33em' }}>
                                                                        We are a Northwestern based start-up radically innovating the way we care.
          </p>
                                                                <Header as='h3' style={{ fontSize: '2em' }}>
                                                                        Contact Us:
          </Header>
                                                                <p style={{ fontSize: '1.33em' }}>
                                                                        Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                                                                        call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                                                        </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row>
                                                        <Grid.Column textAlign='center'>
                                                                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
                                                        </Grid.Column>
                                                </Grid.Row>

                                        </Grid>
                                </Segment>
                                <Segment inverted vertical style={{ padding: '5em 0em' }}>
                                        <Container>
                                                <Grid divided inverted stackable>
                                                        <Grid.Row>
                                                                <Grid.Column width={3}>
                                                                        <Header inverted as='h4' content='Follow us' />
                                                                        <List link inverted>
                                                                                <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                                                                                <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                                                                                <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                                                            
                                                                        </List>
                                                                </Grid.Column>
                                                                <Grid.Column width={3}>
                                                                        <Header inverted as='h4' content='Contact us' />
                                                                        <List link inverted>
                                                                                <List.Item>homecarenuvention@gmail.com</List.Item>
                                                                               
                                                                        </List>
                                                                </Grid.Column>
                                                                <Grid.Column width={7}>
                                                                        <Header as='h4' inverted>
                                                                                Homecare
            </Header>
                                                                        <p>
                                                                                Help us help you care.
            </p>
                                                                </Grid.Column>
                                                        </Grid.Row>
                                                </Grid>
                                        </Container>
                                </Segment>
                        </Responsive>
                )
        }
}

MobileContainer.propTypes = {
        children: PropTypes.node,
}

const ResponsiveContainer = ({ children }) => (
        <div>
                <DesktopContainer>{children}</DesktopContainer>
                <MobileContainer>{children}</MobileContainer>
        </div>
)

ResponsiveContainer.propTypes = {
        children: PropTypes.node,
}

const RequestDemo = () => {

        const someContext = useContext(AppState);
        const {
                articles,
                setArticles,
        } = someContext;
        const [loader, setLoader] = useState(true);
        setTimeout(() => { setLoader(false) }, 2000)
        return (<ResponsiveContainer>
                {/* <ModalBlogLogin /> */}
                <Segment style={{ padding: '4em 0em' }} vertical>
                        <ContactUs />

                        {/* <Grid container > */}
                                {/* <Grid.Row>
          <Grid.Column width={14}> */}
                                {/* <p as='h3' style={{ fontSize: '1.33em' }}>

                                </p> */}


                                {/* {Object.values(articles).map((input) =>
                                        <Grid.Row>
                                                <Grid.Column style={{ maxWidth: 1000, alignItems: "center" }}>
                                                        <Card
                                                                fluid
                                                                raised
                                                                href={'/blog/' + input["id"]}
                                                                header={input["Title"]}
                                                                meta={input["Date"]}
                                                                description={input["Intro"]}
                                                        />
                                                </Grid.Column>
                                        </Grid.Row>
                                )} */}
                                <br />

                        {/* </Grid> */}
                </Segment>

        </ResponsiveContainer>)
}

const NewYork = () => {
        const contextRef = createRef();
        return (


                <Ref innerRef={contextRef}>

                        <Segment style={{ padding: '3em 0em' }} vertical >
                                {/* <Sticky active={false} context={contextRef}>
   <Rail position='top'>
  
                  <Image src='https://react.semantic-ui.com/images/wireframe/image.png' />
                
              </Rail>
              </Sticky> */}
                                <Grid.Row>
                                        <Grid.Column width={16} >
                                                <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
        </Header>
                                        </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                        <Grid.Column width={14}>
                                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                                        Senior Centers
          </Header>
                                                <p style={{ fontSize: '1.30em' }}>
                                                        If your parent is 60+, you may know that senior centers have already been closed. However, a few centers (found <a href="//www1.nyc.gov/site/dfta/services/find-help.page" target="_blank">here</a>) are still operational in providing lunches every weekday from 11:00 am to 1:00 pm. If an aide will be going to pick up meals, they should definitely try to communicate with the center in advance. The NYCFoodPolicy organization also recommends asking about the following before visiting a local center: meal delivery, the hours of operation, and the possibility of extra meals.
        </p>
                                        </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                        <Grid.Column width={14}>
                                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                                        Special Supermarket Operating Hours for Seniors
        </Header>
                                                <p style={{ fontSize: '1.30em' }}>
                                                        Costco: Open from 8 am to 9 am on Tuesdays and Thursdays for individuals over 60. Find a store <a href="//www.costco.com/warehouse-locations" target="_blank">here</a>.
              Dollar General: Opens 1 hour early for seniors. Find a store <a href="//www.dollargeneral.com/store-locator.html" target="_blank">here.</a>
              Fairway Market: Open from 8 am to 9 am to individuals over 65, as well as others with increased risk to serious illness and expecting mothers. Find a store <a href="//www.fairwaymarket.com/store-locator/" target="_blank">here.</a>
              Target: First shopping hour on Wednesdays is kept for seniors. Find a store <a href="//www.target.com/store-locator/find-stores/new%20york,ny" target="_blank">here</a>.
              Trader Joe’s: From 9 am to 10 am there is a reserved line for seniors to guarantee expedited service. Find a store <a href="//www.traderjoes.com/stores?q=" target="_blank">here</a>.
        </p>
                                        </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                        <Grid.Column width={14}>
                                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                                        Non-Profit Delivery Services
</Header>
                                                <p style={{ fontSize: '1.30em' }}>
                                                        CityMeals on Wheels:  Provides delivered meals to those over 60 years old with some other eligibility requirements found <a href="https://www.citymeals.org/get-meals" target="_blank">here.</a>
              For example, they requires a Case Manager. You can find more on their remarkable work at the end of the article.
              God’s Love We Deliver: Provides delivered meals to eligible individuals, mostly those who are not well enough to cook or shop
              by themselves. Eligibility requirements and application information found <a href="https://www.glwd.org/get-meals/for-you-or-your-loved-ones/" target="_blank">here.</a>
              If there are any more questions, please reach out to us at homecarenuvention@gmail.com or contact info@nycfoodpolicy.org.
              Alternatively, you can also call Emergency Food Hotline: 866-888-8777 or the Housing Assistance line: 311.
        </p>
                                        </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                        <Grid.Column width={14}>
                                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                                        Other Services (i.e. Homecare)
</Header>
                                                <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
                                                        If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication
                                                        and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers
              or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.

        </p>
                                        </Grid.Column>
                                </Grid.Row>
                        </Segment>
                </Ref>
        )
}

const Chicago = () => (
        <Segment style={{ padding: '3em 0em' }} vertical>
                <Grid.Row>
                        <Grid.Column width={16} >
                                <Header as='h3' style={{ fontSize: '1.63em' }} >Ensuring food needs are met
        </Header>
                        </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                        <Grid.Column width={14}>
                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                        Chicago State Government Home Delivery
          </Header>
                                <p style={{ fontSize: '1.30em' }}>
                                        Chicago State Government’s Home Delivered Meals Program: This effort provides nutritious meals to older persons (60 years and older) who are “frail and/or home bound because of illness or incapacitating disability or are otherwise isolated.” Seniors can both register by contacting 312-744-4016 any time between 9 a.m. – 5 p.m., Monday-Friday. See listing and contact information <a href="//www.chicago.gov/content/dam/city/depts/fss/supp_info/SeniorServices/HDM/HDMprojectlistbypsa080119.pdf" target="_blank"><u>here</u></a>. As context, the Meals on Wheels Chicago program works as a partner of this program and has delivered over 61,000 Emergency Meals this year, providing each client with 5 days of meals.

{/* /content/dam/city/depts/fss/supp_info/SeniorServices/HDM/HDMprojectlistbypsa080119.pdf */}
                                </p>
                        </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                        <Grid.Column width={14}>
                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                        Salvation Army Chicago
        </Header>
                                <p style={{ fontSize: '1.30em' }}>

                                        Their congregate senior and community meals that were occurring daily or weekly are now providing meals in to-go boxes or working with food delivery as necessary. The locations of this pickup and delivery options can be found
<a href="//centralusa.salvationarmy.org/metro/news/salvation-army-food-pantries-open-throughout-division/" target="_blank"> <u>here</u> </a> and you can contact them <a href="//centralusa.salvationarmy.org/metro/emergency-assistance-and-homelessness-prevention/" target="_blank"> <u>here</u> </a>.
        </p>
                        </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                        <Grid.Column width={14}>
                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                        Greater Chicago Food Depository:
</Header>
                                <p style={{ fontSize: '1.30em' }}>
                                        Serves anyone in need of food assistance can turn to the Food Depository’s network of agencies and programs by modifying distributions to promote social distancing, including offering pre-packaged boxes of groceries. To reach them, contact  call 773-843-5416 on Mondays-Fridays between 8:30 a.m. and 5 p.m.

        </p>
                        </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                        <Grid.Column width={14}>
                                <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                                        Other Services (i.e. Homecare)
</Header>
                                <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
                                        If you are managing care for your parents during this time, the Homecare app is the simplest solution for streamlined communication and task management. Know not only if but also when tasks are completed. No longer is it necessary to text back and forth with caregivers or your siblings. Find out more <a href="/" target="_blank"> <u>here</u></a>.
        </p>
                        </Grid.Column>
                </Grid.Row>
        </Segment>
)


export default RequestDemo;